import { Typography } from 'antd';
import Form from './Form';

export const MAX_INPUT_PX_WIDTH = 600;
export default Form;

const TEXT_STYLES = {
  STYLED: {
    color: '#393939',
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '14px',
    // textTransform removed so it's just normal casing now
    textTransform: 'none',
    fontWeight: 700,
    letterSpacing: '1.29px',
  },
  UNSTYLED: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 'normal',
    textTransform: 'none',
    letterSpacing: '0px',
    wordSpacing: '1px',
    textIndent: '0',
    whiteSpace: 'normal',
  },
};

export const FormItemLabel = ({ title, unstyledTitle, subTitle, showAsterisk }) => {
  const style = unstyledTitle ? TEXT_STYLES.UNSTYLED : TEXT_STYLES.STYLED;

  return (
    <span className="inline-flex">
      {showAsterisk && <span className="text-red-500 mr-1 leading-none mt-1">*</span>}

      <span className="flex flex-col">
        <Typography.Text style={style}>{title}</Typography.Text>

        {subTitle && (
          <Typography.Text type="secondary" style={TEXT_STYLES.UNSTYLED} className="mt-0.5">
            {subTitle}
          </Typography.Text>
        )}
      </span>
    </span>
  );
};

export const DatePickerFormItemLabel = ({ title, unstyledTitle }) => (
  <FormItemLabel title={title} subTitle="mm/dd/yyyy" unstyledTitle={unstyledTitle} />
);
